import React from "react";
import { withStyles, Button } from "@material-ui/core";
import RestoreIcon from "@material-ui/icons/Restore";
import DataGrid from '@dataGrid';
import styles from "../../styles";
import GridConfig from "./gridConfig";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import appConstant from "../../../../../appConstants";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";

import { observer, inject } from "mobx-react";
import { withAppConfig } from "../../../../../appConfigContext";
import GridHeader from "./GridHeader";
import AddUpdateTrailer from "./AddUpdateTrailer";
import { getTrailersData } from "../../../../../utilities/fetchData";
import ShowInProgressPopup from "./AddUpdateTrailer/ShowInProgressPopup";
@inject ('CommonStore')
@observer
class TrailerInventory extends React.Component {
  constructor(props){
    super(props);
    this.gridConfig = new GridConfig({
      featureFlags: {
        IsWeightBasedRoutingEnabled: this.props.featureFlags.isFeatureEnabled(
          appConstant.features.isWeightBasedRouting
        ),
        shouldShowTwoManInTrailerInventory: this.props.configJSON.shouldShowTwoManInTrailerInventory ?? false
      }
    });
    this.state = {
      selectedTrailers: null,
      addUpdateDrawerMode: '',
      selectedTrailerForEdit: null,
      searchText: '',
      selectionChangedWhenDrawerOpen: false
    };
  }

  componentDidMount() {
    if (this.getIsDispatchHeaderActive() && !this.props.CommonStore.availableTrailers.length) {
      this.updateTrailerDataInStore();      
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.userData.userProfile.terminal.code !== this.props.userData.userProfile.terminal.code){
      if (this.getIsDispatchHeaderActive()) {
        this.updateTrailerDataInStore();
      }
      this.closeSideDrawer();
    }
  }

  getIsDispatchHeaderActive = () => {
    return JSON.parse(localStorage.getItem('isDispatchHeaderActive'));
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  onSelectionChanged = () => {
    if (this.gridApi) {
      const selectedTrailers = this.gridApi.getSelectedRows();
      this.setState({ selectedTrailers });
    }
  };

  onCellFocused = (params) => {
    if (this.state.addUpdateDrawerMode && (!params.event.ctrlKey || this.state.selectedTrailers)) {
      this.setState({
        selectionChangedWhenDrawerOpen: true
      });
    }
  };

  cancelDuplicateSelection = () => {
    this.setState({
      selectionChangedWhenDrawerOpen: false
    });
  };

  openSideDrawer = (isUpdate = false) => {
    if (this.state.addUpdateDrawerMode || !this.hasAdminAccess()) return;
    if (isUpdate) {
      this.setState({
        addUpdateDrawerMode: appConstant.ADD_UPDATE_FORM_MODES.UPDATE,
        selectedTrailerForEdit: this.state.selectedTrailers[0]
      });
    } else {
      this.setState({ addUpdateDrawerMode: appConstant.ADD_UPDATE_FORM_MODES.ADD });
    }
  };
  
  closeSideDrawer = () => {
    this.setState({
      addUpdateDrawerMode: '',
      selectedTrailerForEdit: null,
      selectedTrailers: null
    });
    this.gridApi.deselectAll();
  };

  hasAdminAccess = () => {
    return this.props.userData.userProfile.isAdmin;
  };

  updateTrailerDataInStore = async () => {
    const { terminal } = this.props.userData.userProfile;
    let trailerData = await getTrailersData(terminal);
    this.props.CommonStore.updateTrailersData(trailerData);
  };

  updateSearchText = (searchText) => {
    this.setState({
      searchText
    });
  };

  checkIfUpdateTrailer = () => {
    return this.state.addUpdateDrawerMode === appConstant.ADD_UPDATE_FORM_MODES.UPDATE;
  };

  render() {
    const { classes } = this.props;
    const trailerInventoryData =
      this.props.CommonStore.availableTrailers.length > 0
        ? this.props.CommonStore.availableTrailers.slice()
        : '';
    return (
      <div className={classes.flexContainer}>
        <header className={classes.moduleHeader} data-automationid="trailerInventory-title">
          Trailer Inventory
        </header>
        <div className={classes.mainContent}>
          <div className={classes.moduleContainer}>
            <div className={classes.moduleMessage}>
              {`Trailers available at the  ${this.props.configJSON.terminalAccessLabel.fullName.toLowerCase()}. Trailer properties can be modified here. Note: Optimization results will be affected.`}
            </div>
            <GridHeader
              selectedTrailers={this.state.selectedTrailers}
              isAddUpdateDrawerOpen={this.state.addUpdateDrawerMode}
              openSideDrawer={this.openSideDrawer}
              hasAdminAccess={this.hasAdminAccess}
              updateSearchText={this.updateSearchText}
            />
            <div className={`${classes.gridContainer} ${classes.gridSmallPadding}`}>
              <div className={`${classes.dataGrid} ${classes.trailerInventoryGrid}`}>
                <DataGrid
                  defaultColDef={this.gridConfig.config.defaultColDef}
                  getRowId={(params) => params.data.trailerId}
                  columnDefs={this.gridConfig.config.columns}
                  config={this.gridConfig.config}
                  rowData={trailerInventoryData}
                  quickFilterText={this.state.searchText}
                  onGridReady={this.onGridReady}
                  onSelectionChanged={this.onSelectionChanged}
                  onCellMouseDown={this.onCellFocused}
                />
              </div>
            </div>
            <div>
              <Button
                color="primary"
                variant="contained"
                size="small"
                classes={{ root: classes.actionButton, disabled: classes.actionDisabled }}
                disabled>
                <RestoreIcon classes={{ root: classes.restoreIcon }} /> Restore to Defaults
              </Button>
            </div>
          </div>
          {this.state.addUpdateDrawerMode && (
            <AddUpdateTrailer
              isUpdateTrailer={this.checkIfUpdateTrailer()}
              terminalId={this.props.userData.userProfile.terminal.id}
              closeSideDrawer={this.closeSideDrawer}
              selectedTrailerData={this.state.selectedTrailerForEdit}
              updateTrailerDataInStore={this.updateTrailerDataInStore}
            />
          )}
          {this.state.selectionChangedWhenDrawerOpen && (
            <ShowInProgressPopup
              isUpdateTrailer={this.checkIfUpdateTrailer()}
              onClose={this.cancelDuplicateSelection}
            />
          )}
        </div>
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar,
  withFeatureFlags,
  withAppConfig
)(TrailerInventory);
